<mat-card appearance="outlined" *ngIf="!!dynamicContent">
  <h2>{{ 'dynamicContent.media' | translate }}</h2>

  <div class="main-actions">
    <button (click)="chooseFromImageAssets()" class="ibexfusion-raised-button small" mat-button>{{ 'dynamicContent.chooseImage' | translate }}
    </button>
    <button *ngIf="!imageOnly && !imagesOnly"  (click)="chooseFromVideoAssets()" class="ibexfusion-raised-button small"
            mat-button>{{ 'dynamicContent.chooseVideo' | translate }}
    </button>
  </div>

  <div class="action-header" [ngClass]="{ active: !!selectedFiles?.length }">
    <div class="count">{{selectedFiles?.length}} {{'general.selectedEntries' + (selectedFiles.length > 1 ? 'Multi' : 'Single') | translate}}</div>

    <mat-form-field *ngIf="checkBoxActions" >
      <mat-select [disabled]="!selectedFiles?.length" [placeholder]="'general.selectionActions' | translate">
        <mat-option (click)="action.action()" *ngFor="let action of checkBoxActions">
          <mat-icon *ngIf="action.icon">{{action.icon}}</mat-icon>
          {{action.translation | translate}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="table-header">
    <ibex-checkbox *ngIf="!imageOnly" #checkboxAll [id]="'checkboxAll'" (click)="selectItemsAll()"></ibex-checkbox>
    <div class="preview"></div>
    <div class="title">{{'general.title' | translate}}</div>
    <div class="drag" *ngIf="!imageOnly">
      <mat-icon>keyboard_arrow_up</mat-icon>
      <mat-icon>keyboard_arrow_down</mat-icon>
    </div>
    <div class="date">{{ 'general.created' | translate }}</div>
    <div class="size">{{'general.size' | translate}}</div>
    <div class="actions"></div>
  </div>

  <div (cdkDropListDropped)="dropImage($event)" cdkDropList class="table">
    <div *ngFor="let file of dynamicContent.mediaFiles; let i = index" cdkDrag [cdkDragDisabled]="dynamicContent?.mediaFiles?.length <= 1" cdkDragBoundary=".table" class="table-row">
      <div *cdkDragPlaceholder class="drag-placeholder"></div>
      <ibex-checkbox *ngIf="!imageOnly" (click)="selectItem(file)"></ibex-checkbox>
      <div class="preview">
        <smart-image (mouseenter)="hover(file, $event)" (mouseleave)="leave()" *ngIf="!file.mimeType.includes('video')" [url]="imageAssetPath + file.url + '/oneToOne'" class="image"></smart-image>
        <div class="video" *ngIf="file.mimeType.includes('video')"><ibex-icon variant="blank" name="play"></ibex-icon></div>
      </div>
      <div class="title">{{ filesByPath[file.url]?.title || filesByPath[file.url]?.originalFileName }}</div>
      <div class="drag-button" *ngIf="!imageOnly" cdkDragHandle>
        <button class="drag ibexfusion-icon-button" mat-icon-button matTooltip="{{'packages.installedApps.dragTip'| translate}}">
          <mat-icon>drag_indicator</mat-icon>
        </button>
      </div>
      <div class="date">
        <ng-container *ngIf="filesByPath[file.url]?.created">{{ filesByPath[file.url].created | date:'dd.MM.YYYY' }}</ng-container>
      </div>
      <div class="size">
        <ng-container *ngIf="filesByPath[file.url]?.fileSize">{{ filesByPath[file.url].fileSize | fileSize }}</ng-container>
      </div>
      <div class="actions">
        <button *ngIf="!file.mimeType.includes('video')" (click)="editMedia(filesByPath[file.url])" class="ibexfusion-icon-button" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
        <button *ngIf="!!file.mimeType.includes('video')" (click)="editAsset(filesByPath[file.url])" class="ibexfusion-icon-button" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
        <button (click)="downloadFile(i)" class="ibexfusion-icon-button" mat-icon-button>
          <mat-icon>download</mat-icon>
        </button>
        <button (click)="disconnectImage(i)" class="ibexfusion-icon-button" mat-icon-button>
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <p *ngIf="!dynamicContent.mediaFiles || !dynamicContent.mediaFiles.length" class="no-file">{{ 'dynamicContent.noMedia' | translate }}</p>
</mat-card>
